export default "__VITE_ASSET__DzQRz9aB__"